import { isWholeWeek } from 'core/domain/Weekday'
import { getTruckLabel } from 'core/presenters/truckPresenter'
import { formatWeekdayShort } from 'core/presenters/WeekdayPresenter'
import { formatDate, parseISO } from 'core/utils/date'

import { type PreferredLane, getRadius } from '../domain/PreferredLane'
import { formatDescription } from './PlacePresenter'

export function formatEquipment(preferredLane: PreferredLane) {
  return (
    preferredLane.equipmentTypes
      ?.map(equipment => getTruckLabel(equipment) ?? equipment)
      .join(', ') || undefined
  )
}

export function formatPeriod(preferredLane: PreferredLane) {
  if (preferredLane.startsAt && preferredLane.expiresAt) {
    const startsAt = formatDate(parseISO(preferredLane.startsAt), 'LLL d')
    const expiresAt = formatDate(parseISO(preferredLane.expiresAt), 'LLL d')

    return `${startsAt} — ${expiresAt}`
  }
}

export function formatRadius(preferredLane: PreferredLane) {
  return `${getRadius(preferredLane)} mi`
}

export function formatTitle(preferredLane?: PreferredLane) {
  const origin = formatDescription(preferredLane?.origin)
  const destination = formatDescription(preferredLane?.destination)

  return `${origin} → ${destination}`
}

export function formatTooltipMessage(preferredLane: PreferredLane) {
  const { origin, destination, equipmentTypes } = preferredLane

  return {
    origin: formatDescription(origin),
    destination: formatDescription(destination),
    equipmentTypes: equipmentTypes ? `(${equipmentTypes?.join(',')})` : undefined,
  }
}

export function formatWeekdays(preferredLane: PreferredLane) {
  if (isWholeWeek(preferredLane.weekdays)) {
    return 'Everyday'
  }

  return preferredLane.weekdays?.map(formatWeekdayShort).join(', ') || undefined
}
